if (!window.Eurus.loadedScript.includes('bexit-theme.js')) {
  window.Eurus.loadedScript.push('bexit-theme.js')

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('bexitHeaderMenu', {
        isSticky: false,
        stickyCalulating: false,
        isTouch:
          'ontouchstart' in window ||
          (window.DocumentTouch && window.document instanceof DocumentTouch) ||
          window.navigator.maxTouchPoints ||
          window.navigator.msMaxTouchPoints
            ? true
            : false,
        sectionId: '',
        stickyType: 'none',
        lastScrollTop: 0,
        themeModeChanged: false,
        showLogoTransparent: true,
        offsetTop: 0,
        activeMenu: null,

        setActiveMenu(el) {
          if (!el) {
            return
          }
          const mainContent = document.querySelector('#MainContent')
          const toggleMegaMenu = document.querySelector('#ToggleMegaMenu')
          if (mainContent && toggleMegaMenu) {
            // const computedStyle = getComputedStyle(toggleMegaMenu);
            // const elementPadding = parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
            // const elementHeight = toggleMegaMenu.clientHeight - elementPadding;
            document.querySelector('#MainContent').style.marginTop = `${65}px`
          }
          this.activeMenu = el
        },
        clearToggleMenus(items, isSub) {
          if (!items) {
            return
          }

          // Cleanup all toggle-menus
          for (var i = 0; i < items.length; i++) {
            if (isSub) {
              items[i].style.display = 'none'
            } else {
              items[i].style.maxHeight = '0px'
              items[i].style.opacity = '0'
              items[i].classList.add('max-h-0', 'overflow-hidden', 'hidden')
            }
          }
        },
        selectItem({ el, isSub = false, deselect = false }) {
          if (!el) {
            console.error(`Alpine.store.xHeaderMenu.selectItem: Element ${el} is not defined`)
            const items = document.querySelectorAll('.toggle-menu')
            this.clearToggleMenus(items)
            return
          }

          if (el.querySelector('.mega-list-nav')) {
            el.style.setProperty('--mega-menu-height', el.querySelector('.mega-menu-container').offsetHeight + 'px')
          }
          el.style.setProperty(
            '--header-container-height',
            document.getElementById('x-header-container').offsetHeight + 'px',
          )
          const itemSelector = isSub ? '.toggle-menu-sub' : '.toggle-menu'

          const items = isSub
            ? el.closest('.toggle-menu').querySelectorAll(itemSelector)
            : document.querySelectorAll(itemSelector)

          this.clearToggleMenus(items, isSub)

          // Toggle only interested toggle-menu
          let toggleMenu = el.querySelector(itemSelector)

          if (toggleMenu) {
            if (isSub && !deselect) {
              toggleMenu.style.display = 'flex'
            } else {
              toggleMenu.style.maxHeight = ''
              toggleMenu.style.opacity = '1'
              toggleMenu.classList.remove('max-h-0', 'overflow-hidden', 'hidden')
            }
          }
        },
        hideMenu() {
          var items = document.querySelectorAll('.toggle-menu')
          for (var i = 0; i < items.length; i++) {
            items[i].style.maxHeight = '0px'
            items[i].style.opacity = '0'
            items[i].classList.add('overflow-hidden')
          }
        },

        // start handle touch menu on the ipad
        touchItem(el, isSub = false) {
          const touchClass = isSub ? 'touched-sub' : 'touched'

          el.addEventListener('touchend', (e) => {
            if (el.classList.contains(touchClass)) {
              window.location.replace(el.getAttribute('href'))
            } else {
              e.preventDefault()
              var dropdown = document.querySelectorAll(`.${touchClass}`)
              for (var i = 0; i < dropdown.length; i++) {
                dropdown[i].classList.remove(touchClass)
              }

              el.classList.add(touchClass)
              this.selectItem({ el: el.closest('.has-dropdown'), isSub })
            }
          })
        },

        // handle sticky header
        initSticky(el, sectionId, stickyType) {
          this.sectionId = sectionId
          this.stickyType = stickyType
          this.offsetTop = el.offsetTop
          el.style.height = document.getElementById('sticky-header').offsetHeight + 'px'
          window.addEventListener('resize', () => {
            this.reCalculateHeaderHeight()
          })
        },
        handleAlwaysSticky() {
          const scrollPos = window.pageYOffset || document.documentElement.scrollTop
          const stickyLine = document.getElementById(this.sectionId).offsetTop

          if (scrollPos > stickyLine) this.addStickyHeader()
        },
        handelOnScrollSticky() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop

          if (scrollTop < this.offsetTop) {
            requestAnimationFrame(() => {
              document.getElementById('sticky-header').classList.remove('sticky-header')
            })
          }

          if (Math.abs(scrollTop - this.lastScrollTop) > 10) {
            if (scrollTop < this.lastScrollTop) {
              document.getElementById('sticky-header').classList.remove('header-up', 'opacity-0')
              this.setVariableHeightHeader(true)
            } else if (!this.themeModeChanged) {
              document.getElementById('sticky-header').classList.add('header-up')
              this.setVariableHeightHeader(false)
            }
            this.lastScrollTop = scrollTop
          }
          this.themeModeChanged = false
        },
        addStickyHeader() {
          let isMiniCartOpen = false
          if (Alpine.store('xMiniCart').open && this.stickyType != 'on-scroll-up') {
            isMiniCartOpen = true
            requestAnimationFrame(() => {
              Alpine.store('xMiniCart').hideCart()
            })
          }

          requestAnimationFrame(() => {
            let stickyEl = document.getElementById('sticky-header')
            stickyEl.classList.add('sticky-header', 'reduce-logo-size')

            this.isSticky = true
            this.showLogoTransparent = false
          })

          requestAnimationFrame(() => {
            let stickyEl = document.getElementById('sticky-header')
            if (this.stickyType == 'on-scroll-up') {
              setTimeout(() => {
                stickyEl.classList.add('on-scroll-up-animation')
              }, 500)
            }
            if (!Alpine.store('xMiniCart').open || window.innerWidth > 768) {
              if (this.stickyType == 'always' || this.stickyType == 'reduce-logo-size')
                stickyEl.classList.add('always-animation')
            }
          })

          if (isMiniCartOpen) {
            requestAnimationFrame(() => {
              Alpine.store('xMiniCart').openCart()
            })
          }
        },
        removeStickyHeader() {
          this.isSticky = false
          this.showLogoTransparent = true
          requestAnimationFrame(() => {
            document
              .getElementById('sticky-header')
              .classList.remove('sticky-header', 'reduce-logo-size', 'always-animation', 'on-scroll-up-animation')
            this.reCalculateHeaderHeight()
            this.setVariableHeightHeader(false)
          })
        },
        handleChangeThemeMode() {
          this.themeModeChanged = true
          this.reCalculateHeaderHeight()
        },
        reCalculateHeaderHeight() {
          document.getElementById('x-header-container').style.height =
            document.getElementById('sticky-header').offsetHeight + 'px'
        },
        addTransparentHover(el) {
          el.classList.add('sticky-header-active')
        },
        removeTransparentHover(el) {
          el.classList.remove('sticky-header-active')
        },
        setVariableHeightHeader(sticky) {
          let root = document.documentElement
          if (sticky) {
            root.style.setProperty('--height-header', document.getElementById('sticky-header').offsetHeight + 'px')
          } else {
            root.style.setProperty('--height-header', '0px')
          }
        },
        setTopStickyHeader() {
          let root = document.documentElement
          root.style.setProperty('--top-header', document.getElementById('sticky-header-content').offsetHeight + 'px')
        },
      })
    })
  })
}